import { ComponentGroup, ComponentSeverity } from "./monitoringData";

export interface DeviceNavigationResponse {
    device: DeviceNavigationDevice;
    items: DeviceNavigationItem[];
    features: string[];
}

export interface DeviceNavigationDevice {
    deviceUuid: string;
    displayName: string;
    deviceType: number;
    templateRef: string;
    role: string;
    parentDeviceUuid?: string | null;
    defaultFeatureRef?: string | null;
}

export enum DeviceNavigationStatus {
    none = "None",
    info = "Info",
    warning = "Warning",
    error = "Error"
}

export interface DeviceNavigationItem {
    itemType: "Device" | "Feature";
    title: string;
    order: number;
    featureRef?: string | null;
    permissionKey?: string | null;
    featureKind?: "Static" | "Dynamic" | null;
    iconKey?: string | null;
    deviceUuid?: string | null;
    deviceType?: number | null;
    templateRef?: string | null;
    role?: string | null;
    parentDeviceUuid?: string | null;
    status?: {
        severity: DeviceNavigationStatus,
        count: number,
        text: string
    } | null;
    defaultFeatureRef?: string | null;
    childrens?: DeviceNavigationItem[];
}
export interface DeviceFeatureResponse {
    device: DeviceNavigationDevice;
    featureRef: string;
    title: string;
    permissionKey: string;
    groups: ComponentGroup[];
}
